"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDDConfigPage = void 0;
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("@hookform/resolvers/zod");
const polaris_1 = require("@shopify/polaris");
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
const layout_1 = require("@/common/components/layout");
const components_1 = require("@/common/components");
const text_1 = require("@/common/components/text");
const hooks_1 = require("@/edd/common/hooks");
const edd_config_page_validation_1 = require("./edd-config-page.validation");
const helpers_1 = require("@/edd/common/helpers");
const edd_1 = require("@/domains/edd");
const hooks_2 = require("@/edd/common/hooks");
const edd_config_page_graphql_1 = require("./edd-config-page.graphql");
const AccountContext_1 = require("contexts/AccountContext");
const DAY_DEFAULTS = hooks_2.DAYS_OF_WEEK.reduce((acc, day) => {
    acc[day] = {
        enabled: true,
        cutoffTime: '17:00'
    };
    return acc;
}, {});
const DEFAULT_VALUES = {
    template: '',
    orderFulfillmentConfig: Object.assign({ minDays: '1', maxDays: '3', fixedDate: false }, DAY_DEFAULTS)
};
const EDDConfigPage = () => {
    var _a;
    const { config, refetch: refetchEDDConfig, error, loading } = (0, hooks_1.useEDDConfig)();
    const { previewHTML, refetch: refetchPreviewHTML } = (0, hooks_1.useEDDPreview)();
    const { account } = (0, AccountContext_1.useAccount)();
    const { variables } = (0, hooks_1.useEDDVariables)();
    const [loadingUpdate, _setLoadingUpdate] = (0, react_1.useState)(false);
    const [errorBannerMsg, setErrorBannerMsg] = (0, react_1.useState)(null);
    const [successBannerMsg, setSuccessBannerMsg] = (0, react_1.useState)(null);
    const [templateIsDirty, setTemplateIsDirty] = (0, react_1.useState)(false);
    const configForm = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        defaultValues: DEFAULT_VALUES,
        resolver: (0, zod_1.zodResolver)(edd_config_page_validation_1.eddConfigFormSchema)
    });
    const [updateEDDConfig] = (0, client_1.useMutation)(edd_config_page_graphql_1.UPDATE_EDD_CONFIG, {
        onCompleted: () => {
            handleFormBannerDismiss();
            setSuccessBannerMsg('Configuration has been successfully updated!');
            refetchEDDConfig();
            refetchPreviewHTML();
        },
        onError: (errorDetail) => {
            handleFormBannerDismiss();
            errorDetail.networkError
                ? setErrorBannerMsg("The server can't be reached. Please try again later.")
                : setErrorBannerMsg(errorDetail.message);
        }
    });
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = configForm.formState.dirtyFields) === null || _a === void 0 ? void 0 : _a.template) {
            setTemplateIsDirty(true);
        }
        else {
            setTemplateIsDirty(false);
        }
    }, [(_a = configForm.formState.dirtyFields) === null || _a === void 0 ? void 0 : _a.template]);
    (0, react_1.useEffect)(() => {
        // When config data is received, replace the static form defaults
        if (config) {
            const updated = Object.assign({}, config.orderFulfillmentConfig);
            for (const day of hooks_2.DAYS_OF_WEEK) {
                const entry = config.orderFulfillmentConfig[day];
                if (entry) {
                    updated[day] = Object.assign(Object.assign({}, entry), { cutoffTime: (0, helpers_1.convertTo24Hour)(entry.cutoffTime) });
                }
            }
            updated.fixedDate = !updated.maxDays;
            const formData = Object.assign(Object.assign({}, DEFAULT_VALUES), { template: config.template, orderFulfillmentConfig: updated });
            configForm.reset(formData);
        }
    }, [config]);
    if (error) {
        return renderServerErrorBanner();
    }
    if (loading) {
        return (react_1.default.createElement(layout_1.PolarisPage, { title: 'Estimated Delivery Date' },
            react_1.default.createElement(polaris_1.Layout, null,
                react_1.default.createElement(LoadingSpinner_1.default, null))));
    }
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, configForm),
        react_1.default.createElement(layout_1.PolarisPage, { fullWidth: true, primaryAction: react_1.default.createElement(polaris_1.Button, { disabled: !configForm.formState.isValid, id: 'edd-config-save-button', loading: loadingUpdate, onClick: configForm.handleSubmit(onSubmit), submit: true, variant: 'primary' }, "Save"), title: 'Estimated Delivery Date' },
            react_1.default.createElement(polaris_1.BlockStack, { gap: '400' },
                renderMessageBanner(),
                react_1.default.createElement(polaris_1.Layout, null,
                    react_1.default.createElement(polaris_1.Layout.Section, null,
                        react_1.default.createElement(polaris_1.BlockStack, { gap: '400' },
                            renderDisplayMsgSection(),
                            react_1.default.createElement(edd_1.VariableListCard, { variables: variables }),
                            react_1.default.createElement(edd_1.ProcessingTimeCard, null))),
                    react_1.default.createElement(polaris_1.Layout.Section, { variant: 'oneThird' },
                        react_1.default.createElement(edd_1.EDDPreviewCard, { html: previewHTML })))))));
    function renderMessageBanner() {
        const tone = successBannerMsg ? 'success' : 'critical';
        const message = tone === 'success' ? successBannerMsg : errorBannerMsg;
        if (successBannerMsg || errorBannerMsg) {
            return (react_1.default.createElement("span", { id: 'edd-server-response-banner' },
                react_1.default.createElement(polaris_1.Banner, { onDismiss: handleFormBannerDismiss, title: message || '', tone: tone })));
        }
        return undefined;
    }
    function handleFormBannerDismiss() {
        setErrorBannerMsg(null);
        setSuccessBannerMsg(null);
    }
    function renderDisplayMsgSection() {
        return (react_1.default.createElement(polaris_1.Card, null,
            react_1.default.createElement(polaris_1.BlockStack, { gap: '400' },
                react_1.default.createElement(polaris_1.BlockStack, { gap: '200' },
                    react_1.default.createElement(polaris_1.Text, { as: 'h3', id: 'edd-display-message-card-title', variant: 'headingSm' }, "Shipping Promise"),
                    react_1.default.createElement(polaris_1.Text, { as: 'p', variant: 'bodyMd' }, "Create a Shipping Promise message that will be displayed to your customers on your storefront. Copy and paste the variables to dynamically insert your estimated delivery dates.")),
                react_1.default.createElement(react_hook_form_1.Controller, { control: configForm.control, name: 'template', render: (_a) => {
                        var _b;
                        var _c = _a.field, { value, ref: _ref } = _c, rest = __rest(_c, ["value", "ref"]);
                        return (react_1.default.createElement(polaris_1.TextField, Object.assign({}, rest, { autoComplete: 'off', error: (_b = configForm.formState.errors.template) === null || _b === void 0 ? void 0 : _b.message, helpText: react_1.default.createElement(components_1.MarkdownMessage, null), id: 'edd-config-display-message-text', inputMode: 'text', label: 'Display Message', labelHidden: true, maxLength: 1000, multiline: 2, type: 'text', value: value })));
                    } }),
                templateIsDirty && (react_1.default.createElement(polaris_1.Banner, null, "Current display message updates will be shown in the product page preview upon saving the form.")),
                react_1.default.createElement(polaris_1.Text, { as: 'h3', id: 'edd-config-variables-header', variant: 'headingSm' }, "Variables")),
            react_1.default.createElement(polaris_1.Box, { paddingBlockStart: '300' }, renderVariableList())));
    }
    function renderVariableList() {
        return (react_1.default.createElement(polaris_1.BlockStack, { gap: '200', id: 'edd-variable-reference-list' }, variables.map((variable) => (react_1.default.createElement(polaris_1.Text, { as: 'p', key: `${variable.name}-variable`, variant: 'bodyMd' },
            react_1.default.createElement(text_1.Highlight, null, `{{${variable.name}}}`),
            '  ',
            " = ",
            variable.description)))));
    }
    // Replaces the page when default config values can't be obtained
    function renderServerErrorBanner() {
        return (react_1.default.createElement(layout_1.PolarisPage, { title: 'Estimated Delivery Date' },
            react_1.default.createElement("div", { id: 'edd-config-server-error' },
                react_1.default.createElement(polaris_1.Banner, { title: 'Cannot load estimated delivery date configuration.', tone: 'critical' }, formatServerErrorMessage()))));
    }
    function formatServerErrorMessage() {
        var _a;
        if (error === null || error === void 0 ? void 0 : error.networkError) {
            return 'Server Error: An issue occurred when trying to communicate with the server. Please try again.';
        }
        return `Error: ${(_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.replace(/_/g, ' ')}`;
    }
    function onSubmit(formData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!config || !(account === null || account === void 0 ? void 0 : account.id)) {
                setErrorBannerMsg('Session expired. Please log in again before submitting request.');
                return;
            }
            handleFormBannerDismiss();
            const { activations, dateFormat } = config;
            const { orderFulfillmentConfig: formConfig } = formData;
            const updated = {};
            // add day of week entries with properly formatted time
            for (const day of hooks_2.DAYS_OF_WEEK) {
                const entry = formConfig[day];
                // we don't currently change date format or activations via the form, so grab existing ones
                const staticEntry = config.orderFulfillmentConfig[day];
                if (entry) {
                    updated[day] = {
                        dow: staticEntry.dow,
                        name: staticEntry.name,
                        enabled: entry.enabled,
                        // attempt to convert cutoff time to 12-hour format or set an empty string
                        cutoffTime: (0, helpers_1.convertTo12Hour)(entry.cutoffTime) || ''
                    };
                }
            }
            updated.minDays = formConfig.minDays;
            updated.timeZone = formConfig.timeZone;
            // Only set maxDays if fixedDate was checked and maxDays were provided
            if (!formConfig.fixedDate && formConfig.maxDays) {
                updated.maxDays = formConfig.maxDays;
            }
            yield updateEDDConfig({
                variables: {
                    input: {
                        accountId: account.id,
                        activations,
                        dateFormat,
                        orderFulfillmentConfig: updated,
                        template: formData.template
                    }
                }
            });
        });
    }
};
exports.EDDConfigPage = EDDConfigPage;
